<script lang="ts">
	import { uid } from "@xbs/lib-state";

	import DateRangePicker from "./CustomDateRangePicker.svelte";

	export let start: Date;
	export let end: Date;
	export let format: string;
	export let id: string | number = uid();

</script>

<DateRangePicker bind:start bind:end {id} {format} />
